export default "__VITE_ASSET__BU3RzWGp__"